/** Resolve Canvas API WebSocket base (ws/wss) from REACT_APP_API_URL. */
export function getCanvasWsBaseUrl() {
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL.replace(/\/$/, '');
  }
  const http =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development'
      ? 'http://localhost:8001'
      : window.location.origin);
  if (http.startsWith('ws://') || http.startsWith('wss://')) {
    return http.replace(/\/$/, '');
  }
  return http.replace(/^http/, 'ws').replace(/\/$/, '');
}
